/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Current status of the order.
 */
export const OrderStatus = {
  Pending: "pending",
  Paid: "paid",
} as const;
/**
 * Current status of the order.
 */
export type OrderStatus = ClosedEnum<typeof OrderStatus>;

/** @internal */
export const OrderStatus$inboundSchema: z.ZodNativeEnum<typeof OrderStatus> = z
  .nativeEnum(OrderStatus);
/** @internal */
export const OrderStatus$outboundSchema: z.ZodNativeEnum<typeof OrderStatus> =
  OrderStatus$inboundSchema;
